
<template>
<div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
  <vx-card class="text-center" style="height:180px;" scrollHeight>
    <div class="text-center">
      <!-- <div class="vx-row justify-end">
        <div style="width: 20%;">
          <div class="justify-end">
            <vs-switch color="success" v-model="serviceVal">
              <span slot="on">작성중</span>
              <span slot="off">작성완료</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row justify-end" style="width: 80%;">
        </div>
      </div> -->
      <vs-button class="w-full" color="primary" type="flat" style="font-size: 15px; width:15px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;" @click="activePrompt= true"><strong>{{data_local.subject}} :
          {{data_local.total_score}}점</strong>

      </vs-button>
      <vs-button class="w-full" color="primary" type="flat" style="font-size: 15px; width:15px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;" @click="showGradeLevel()"><strong>원점수(등급)</strong>
      </vs-button>
    </div>
    <div>
      <vs-divider style="margin-top:2px;" />
      <div class="flex justify-center flex-wrap" style="margin-top:10px;">
        <!-- <p style="margin-right:5px;"> {{subjectInfo.subject}} </p> &nbsp; -->
        <vs-button color="primary" style="margin-right:3px" type="border" icon-pack="feather" size="small" icon="icon-list" @click="showSubject()"></vs-button>
      </div>
    </div>
  </vx-card>

  <vs-prompt class="email-compose" title="시험 과목 수정" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="updateSubject" :active.sync="activePrompt">
    <!-- <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl"> -->
    <form @submit.prevent>
      <vs-input class="w-full mt-4" label="과목 이름" v-model="data_local.subject" />
      <!-- <select style="width:30%; margin-bottom:20px; margin-right:5px; margin-left:5px;" v-model="selectSubjectType">
        <option :id="subject.id" v-for="subject in subjectType" :key="subject.id">{{subject.name}}</option>
      </select> -->
      <vs-select label="과목 정보" v-model="data_local.subject_type_id" class="w-full mt-5">
          <vs-select-item :key="subject.id" :value="subject.id" :text="subject.name" v-for="subject in subjectType" />
      </vs-select>
      <vs-select label="디테일 정보" v-model="data_local.subject_detail_type_id" class="w-full mt-5">
          <vs-select-item :key="subject.subject_detail_type_id" :value="subject.subject_detail_type_id" :text="subject.subject_detail_name" v-for="subject in detailType" />
      </vs-select>
      <vs-input class="w-full mt-4" label="추가 정보" v-model="data_local.detail" />
      <vs-input class="w-full mt-4" label="시험 시간 (분단위)" v-model="data_local.time_limit" />
      <!-- <vs-input class="w-full mt-4" label="총 점수" v-model="data_local.total_score" /> -->
      <vs-input class="w-full mt-4" label="총 문제수" v-model="data_local.total_question" />
    </form>
    <!-- </component> -->
  </vs-prompt>

  <vs-prompt class="email-compose" title="원점수(등급표)" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="updateSubjectLevel" :active.sync="activePrompt2">
    <!-- <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl"> -->
    <form @submit.prevent>
      <vs-input class="w-full mt-4" :label="item.name" v-model="item.score" v-for="(item, index) in subjectLevels" :key="index" />

    </form>
    <!-- </component> -->
  </vs-prompt>
</div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  props: ['subjectInfo'],
  data() {
    return {
      serviceVal: true,
      data_local: '',
      activePrompt: false,
      activePrompt2: false,
      detailType: [],
      subjectLevels: [{
        'name': '1등급',
        'score': 0,
        'rating': 1
      }, {
        'name': '2등급',
        'score': 0,
        'rating': 2
      }, {
        'name': '3등급',
        'score': 0,
        'rating': 3
      }, {
        'name': '4등급',
        'score': 0,
        'rating': 4
      }, {
        'name': '5등급',
        'score': 0,
        'rating': 5
      }, {
        'name': '6등급',
        'score': 0,
        'rating': 6
      }, {
        'name': '7등급',
        'score': 0,
        'rating': 7
      }, {
        'name': '8등급',
        'score': 0,
        'rating': 8
      }],
    }
  },
  watch: {
    'data_local.subject_type_id'(){
        this.init()
    },
    detailType() {
      
    },
    serviceVal() {
      this.data_local.subject_state = this.serviceVal ? 0 : 1
      this.$store.dispatch('etest/updateSubjectState', {
        'id': this.data_local.id,
        'subject_state': this.data_local.subject_state
      })
    },
  },
  created() {
    this.data_local = JSON.parse(JSON.stringify(this.subjectInfo))
    console.log(this.data_local)
    this.serviceVal = this.data_local.subject_state == 0 ? true : false
  },
  components: {
    'v-select': vSelect,
  },
  computed: {
    questionList() {
      return this.$store.state.etest.questionList
    },
    subjectType() {
      return this.$store.state.etest.subjectType
    },
    subjectCode(){
      return this.$store.state.etest.subjectCode
    },
    activeExam() {
      return this.$store.state.etest.activeExam
    },
    // AppActiveUser(){
    //
    // }
  },
  methods: {
    init() {
      var detail = JSON.parse(JSON.stringify(this.subjectCode))
      var list = detail.filter((item)=> {
          return item.grade == this.activeExam.grade_id
        })
        this.detailType = list.filter((item)=> {
          return item.subject_type_id == this.data_local.subject_type_id
        })
    },
    showGradeLevel() {
      this.$store.dispatch('etest/getSubjectGradeLevel', this.subjectInfo.id)
        .then((resolve) => {
          if (resolve.length != 0) {
            this.subjectLevels = resolve
          }
          this.activePrompt2 = true
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    updateSubjectLevel() {
      if (!this.subjectLevels[0].id) {
        this.$store.dispatch('etest/createSubjectGradeLevel', {
            id: this.subjectInfo.id,
            grades: this.subjectLevels
          })
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: '완료'
            })
          }).catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: '실패',
              text: '관리자에게 문의 부탁 드립니다.'
            })
          })
      } else {
        this.$store.dispatch('etest/updateSubjectGradeLevel', this.subjectLevels)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: '완료'
            })
          }).catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: '실패',
              text: '관리자에게 문의 부탁 드립니다.'
            })
          })
      }

    },
    clearFields() {},
    updateSubject() {
      this.$store.dispatch('etest/updateEtestSubject', this.data_local)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '완료',
            text: this.data_local.subject + '을 수정하였습니다.'
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    showSubject() {
      this.$store.commit('etest/ACTIVE_SUBJECT', this.subjectInfo)
      this.$store.commit('etest/ACTIVE_QUESTION', {
        id: -1
      })

      // if (this.subjectInfo.defect) {
      //   this.$store.dispatch('etest/getEtestQuestion', this.subjectInfo.id).then(() => {
      //     if (this.questionList.length) {
      //       this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[this.questionList.length - 1])
      //     }
      //     this.$router.push('/app/exam/form')
      //   }).catch(() => {
      //     this.$vs.notify({
      //       color: 'danger',
      //       title: '실패',
      //       text: '관리자에게 문의 부탁 드립니다.'
      //     })
      //   })
      //   return
      // }

      this.$store.dispatch('etest/getEtestQuestion', this.subjectInfo.id).then(() => {
        if (this.questionList.length) {
          this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[this.questionList.length - 1])
        }
        this.$router.push('/app/exam/form')
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })


    }
  }
}
</script>
